// ----------------------------------------------------------------------------
// Component: Klaviyo Embed Form
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

import { register } from '@shopify/theme-sections';

// Styles
import './_klaviyo-embed-form.scss';

register('klaviyo-embed-form', {
    onLoad() {
        // When Shopify re-renders this section in the theme editor, Klaviyo's
        // embed JS won't re-run against the new DOM. Replacing the div with a
        // fresh clone triggers Klaviyo's MutationObserver to re-initialize.
        const formDiv = this.container.querySelector('[class*="klaviyo-form-"]');
        if (!formDiv) return;
        formDiv.replaceWith(formDiv.cloneNode(false));
    }
});
